import { Component, OnInit, ViewChild } from '@angular/core';
import { IOnboardedAppGridModel } from '../../../entities-api/IOnboardedAppGridModel';
import { ContainermappingService } from '../../../services/containermapping.service';
import { GridTypeEnum } from '../../../constants/grid-type.enum';
import { GridResultEnum } from '../../../constants/grid-result.enum';
import { PageService } from '../../../services/page.service';
import { GridResultService } from '../../../services/gridresult.service';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'opm-opm-onboardedapps',
  templateUrl: './opm-onboardedapps.component.html',
  styleUrls: ['./opm-onboardedapps.component.less'],
  standalone: false
})
export class OpmOnboardedappsComponent implements OnInit {
  constructor(private containermappingService: ContainermappingService, private page: PageService, private gridtype: GridResultService) { }
  gridDataModel: IOnboardedAppGridModel;
  gridTypeEnum = GridTypeEnum;
  gridResult: string;
  gridResultEnum = GridResultEnum;
  noMatchesFoundMsg: string = "No matches Found";
  visiblNoMatchesFoundPopup: boolean = false;
  totalCount: number;
  isPagingVisible: boolean = false;
  isUserAuthorized: boolean = false;
  currentPage: number;
  onBoardedAllApps: IOnboardedAppGridModel = {
    OnboardedAppDetails: [],
    TotalCount: 0
  };

  ngOnInit(): void {
    this.containermappingService.getCurrentUserAsync().then(() => {
      this.isUserAuthorized = true;
    },
      () => { // Required handle reject promise
      });
    this.viewOnboardedApps();
  }
  async viewOnboardedApps() {
    this.currentPage = 0;
    this.page.CurrentPageNumber(0);
    this.gridtype.GridresultType(this.gridResultEnum.OnboardedApp);
    this.gridResult = this.gridtype.gridResult;
    await this.getOnboardedApps();
    await this.getAllOnBoardedApps();
  }
  async getOnboardedApps() {
    await this.containermappingService.getOnboardedApps(this.currentPage, false).then((data: IOnboardedAppGridModel) => {
      this.populateOnBoardedApps(data);
    })
  }
  populateOnBoardedApps(data) {
    this.gridDataModel = data;
    this.noMatchesFoundMsg = "No matches Found";
    this.visiblNoMatchesFoundPopup = data.OnboardedAppDetails.length === 0;
    this.totalCount = data.TotalCount;
    this.isPagingVisible = data.OnboardedAppDetails.length !== 0 && this.totalCount > Constants.PagingConst.RecordsPerPage;
  }
  async getAllOnBoardedApps() {
    await this.containermappingService.getOnboardedApps(this.currentPage, true).then((data: IOnboardedAppGridModel) => {
      this.onBoardedAllApps = data;
    })
  }
  onPageChange(page: number) {
    this.currentPage = page;
    if (this.gridResult == this.gridTypeEnum.OnboardedApp) {
      this.getOnboardedApps();
    }
    else {
      this.refreshModel();
    }
  }
  async refreshModel() {
    await this.containermappingService.getOnboardedApps(this.currentPage, false).then((data: IOnboardedAppGridModel) => {
      this.gridDataModel = data;
      this.noMatchesFoundMsg = "No matches Found";
      this.visiblNoMatchesFoundPopup = data.OnboardedAppDetails.length === 0;
      this.totalCount = data.TotalCount;
      this.isPagingVisible = data.OnboardedAppDetails.length !== 0 && this.totalCount > Constants.PagingConst.RecordsPerPage;
    });
  }
}
